/** @format */

import { Form, Radio, Select, DatePicker, Button } from "antd";
import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { findValuesFromArray, getArrUnique, getBatch } from "utils/helper";
import { getSumberDanaTahap } from "utils/helper/helperBos";
const { RangePicker } = DatePicker;

type FilterVerifType = {
  handleChangeValues: (val: any, allValues?: any) => void;
  handleActionPengajuan: (val: any) => void;
};
export const FilterVerification = ({
  handleChangeValues,
  handleActionPengajuan,
}: FilterVerifType) => {
  const [form] = Form.useForm();
  const {
    sumberDana,
    jenjang,
    jadwalPengajuanBos,
    pengajuanSumberDanaBos,
    penyaluranSumberDanaBos,
  } = useSelector(
    (state: any) => ({
      sumberDana: state.store?.sumberDana,
      jenjang: state.store?.jenjang || [],
      jadwalPengajuanBos: state.bos?.jadwalPengajuanBos || [],
      pengajuanSumberDanaBos: state.bos?.pengajuanSumberDanaBos || [],
      penyaluranSumberDanaBos: state.bos?.penyaluranSumberDanaBos || [],
    }),
    shallowEqual,
  );
  const listBatch = getBatch();

  const batchFilter = [
    ...pengajuanSumberDanaBos,
    ...penyaluranSumberDanaBos,
  ].map((item) => item?.batch);

  const listSumberJadwal = useMemo(
    () => getArrUnique(jadwalPengajuanBos, "sumberdana"),
    [jadwalPengajuanBos],
  );

  const handleResetFormPengajuan = () => {
    form.resetFields();
    handleChangeValues(null);
  };

  return (
    <div className="shadow-xs mb-4 p-4 bg-grey-50">
      <Form
        form={form}
        name="formPencairan"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 8 }}
        labelAlign="left"
        labelWrap
        layout="horizontal"
        onValuesChange={handleChangeValues}
        onFinish={handleActionPengajuan}>
        <Form.Item
          label="Tahapan"
          name="tahap"
          rules={[
            {
              required: true,
              message: "Tahap tidak boleh kosong!",
            },
          ]}>
          <Radio.Group>
            {listSumberJadwal.length &&
              listSumberJadwal.map((item) => {
                return (
                  <Radio key={item} value={getSumberDanaTahap(item)}>
                    {findValuesFromArray(sumberDana, "kode", item, "nama")}
                  </Radio>
                );
              })}
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Jenjang Madrasah" name="jenjang">
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Pilih Jenjang Madrasah">
            {jenjang.length &&
              jenjang.map((e: any) => {
                return (
                  <Select.Option key={`jenjang${e.kode}`} value={e.kode}>
                    {e.nama}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          label="Batch"
          name="batch"
          rules={[
            {
              required: true,
              message: "Batch tidak boleh kosong!",
            },
          ]}>
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Pilih Batch">
            {listBatch?.length &&
              listBatch
                .filter((item) => !batchFilter.includes(item.kode))
                .map((e: any, i: any) => {
                  return (
                    <Select.Option key={`role${i}`} value={e.kode}>
                      {e.nama}
                    </Select.Option>
                  );
                })}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tanggal Mulai dan Akhir"
          name="tanggal"
          rules={[
            {
              required: true,
              message: "Tanggal Mulai dan Tanggal Akhir tidak boleh kosong!",
            },
          ]}>
          <RangePicker
            style={{ width: "100%" }}
            placeholder={["Pilih Tanggal Mulai", "Pilih Tanggal Selesai"]}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="ghost"
            className="mr-2"
            onClick={handleResetFormPengajuan}>
            Reset
          </Button>
          <Button onClick={() => form.submit()} type="primary">
            Ajukan Pencairan
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
